import { create } from 'zustand';

// --- Guest session (persistent id so guest rides are owned by this device) ---
const GUEST_KEY = 'sakaysafe-guest-id';
export function getGuestSession() {
  let id = localStorage.getItem(GUEST_KEY);
  if (!id) {
    // This id acts like a bearer credential for guest ride ownership, so it must
    // be cryptographically unguessable — never Math.random().
    const rand = (typeof crypto !== 'undefined' && crypto.randomUUID)
      ? crypto.randomUUID()
      : (() => { const a = new Uint8Array(16); crypto.getRandomValues(a); return Array.from(a, (b) => b.toString(16).padStart(2, '0')).join(''); })();
    id = 'guest_' + rand.replace(/-/g, '');
    localStorage.setItem(GUEST_KEY, id);
  }
  return id;
}

export const useApp = create((set) => ({
  user: null,            // signed-in user or null (guest)
  authChecked: false,
  // Runtime feature flags from GET /api/config. familyMode defaults to false so
  // the MVP never flashes family UI before config loads.
  familyMode: false,
  configLoaded: false,
  activeRideId: localStorage.getItem('sakaysafe-active-ride') || null,
  sosRideId: localStorage.getItem('sakaysafe-sos-active') || null,
  pendingRating: JSON.parse(localStorage.getItem('sakaysafe-pending-rating') || 'null'),
  onboarded: localStorage.getItem('sakaysafe-onboarded') === '1',

  setUser: (user) => set({ user }),
  setAuthChecked: (v) => set({ authChecked: v }),
  setConfig: (cfg) => set({ familyMode: !!(cfg && cfg.family_mode_enabled), configLoaded: true }),
  setActiveRideId: (id) => {
    if (id) localStorage.setItem('sakaysafe-active-ride', id);
    else localStorage.removeItem('sakaysafe-active-ride');
    set({ activeRideId: id });
  },
  setPendingRating: (obj) => {
    if (obj) localStorage.setItem('sakaysafe-pending-rating', JSON.stringify(obj));
    else localStorage.removeItem('sakaysafe-pending-rating');
    set({ pendingRating: obj });
  },
  setSosRideId: (id) => {
    if (id) localStorage.setItem('sakaysafe-sos-active', id);
    else localStorage.removeItem('sakaysafe-sos-active');
    set({ sosRideId: id });
  },
  completeOnboarding: () => {
    localStorage.setItem('sakaysafe-onboarded', '1');
    set({ onboarded: true });
  },
}));
